import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { formatPrice, constants, snowplow, getElementInViewport, debounce } from 'common/helpers'
import cx from 'classnames'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import ProductCardBase from 'components/product/ProductCardBase/ProductCardBase'

import messages from './messages'
import s from './Product.scss'


class Product extends Component {

  static propTypes = {
    containerClassName: PropTypes.string,
    className: PropTypes.string,
    buttonTitle: PropTypes.object,
    addTo: PropTypes.oneOf([ 'queue', 'cart', false ]),
    defaultSelectedQuickViewType: PropTypes.string,
    link: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
    ]),
    metadata: PropTypes.shape({
      placement: PropTypes.string,
      page: PropTypes.string,
    }),
    snowplowMetadata: PropTypes.object,
    isQuickViewVisible: PropTypes.bool,
    isButtonAlways: PropTypes.bool,
    isHoverEffect: PropTypes.bool,
    isBrandVisible: PropTypes.bool,
    isCategoryVisible: PropTypes.bool,
    isPriceVisible: PropTypes.bool,
    isWholeBlockAsButton: PropTypes.bool,
    isRatingStarBlack: PropTypes.bool,
    data: PropTypes.object,
    lazyImage: PropTypes.bool,
    withoutLink: PropTypes.bool,
    contentNodeInject: PropTypes.node,
    onBlockClick: PropTypes.func,
    onButtonClick: PropTypes.func,
    onAfterAdd: PropTypes.func,
    onQuickViewClick: PropTypes.func,
  }

  static defaultProps = {
    isQuickViewVisible: false,
    isHoverEffect: true,
    isBrandVisible: true,
    isCategoryVisible: true,
    isPriceVisible: false,
    lazyImage: false,
  }

  componentDidMount() {
    const { handleProductInViewport } = this.props

    if (handleProductInViewport) {
      document.addEventListener('scroll', this.handleDocumentScroll)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleDocumentScroll)
  }

  handleDocumentScroll = debounce(() => {
    const { handleProductInViewport, data: { id, name } } = this.props

    const isElementInViewport = getElementInViewport(this.productEl)

    if (isElementInViewport) {
      // TODO looks like we should send this event once, so need to add flag to check if it was already sent - added on 1/20/20 by pavelivanov
      handleProductInViewport({
        id,
        name,
      })
    }
  }, 300)

  setProductElementRef = (element) => {
    this.productEl = element
  }

  handleBlockClick = (event) => {
    const { metadata, onBlockClick } = this.props
    const { recommenderName } = metadata || {}

    // save recommender name for product page
    actions.view.productPage.setRecommenderName(recommenderName)

    if (typeof onBlockClick === 'function') {
      onBlockClick(event)
    }
  }

  handleQuickViewClick = (event) => {
    const {
      data,
      data: { id, previewId, name, category, upchargePrice },
      metadata, defaultSelectedQuickViewType, onQuickViewClick,
    } = this.props

    event.preventDefault()
    event.stopPropagation()

    if (typeof onQuickViewClick === 'function') {
      onQuickViewClick()
    }

    if (upchargePrice) {
      metadata.premium = upchargePrice
    }


    // TODO SNOWPLOW: add properties
    snowplow.track(
      constants.snowplowEvents.quickViewClick,
      {
        // placement,
        productId: id,
        productName: name,
        productCategory: category,
      },
      true,
      { data }
    )

    const { recommenderName } = metadata || {}

    actions.models.modals.open(constants.modals.ProductDetails, {
      productId: previewId || id,
      defaultSelectedQuickViewType,
      recommenderName,
    })
  }

  render() {
    const {
      containerClassName, className, link,
      data, data: { url, img, image, brand, category, name, price, typeGroup },
      isQuickViewVisible, onButtonClick, onAfterAdd, isWholeBlockAsButton,
      isBrandVisible, isCategoryVisible, isPriceVisible,
      lazyImage, contentNodeInject, addTo, buttonTitle, isHoverEffect,
      metadata, onQuickViewClick, snowplowMetadata, defaultSelectedQuickViewType,
      isRatingStarBlack, isButtonAlways, isAddToButtonHidden, children, withoutLink,
    } = this.props

    const contentNode = (
      <Fragment>
        {
          contentNodeInject
        }
        <Box relative>
          {
            isQuickViewVisible && (
              <Fragment>
                <Text
                  className={s.quickViewButton}
                  message={messages.quickView}
                  dataTestId={constants.testIds.payment.quickViewButton}
                  size="12-16"
                  align="center"
                  color="white"
                  tag="button"
                  uppercase
                  onClick={this.handleQuickViewClick}
                />
              </Fragment>
            )
          }
          {
            isBrandVisible && (
              <Text message={brand} size="14-24" semibold uppercase dataTestId="productBrand" />
            )
          }
          <Box mt={4}>
            <Text message={name} size="14-24" dataTestId="productName" />
          </Box>
          {
            isCategoryVisible && (
              <Box mt={4}>
                <Text message={category} size="14-24" dataTestId="productCategory" />
              </Box>
            )
          }
          {
            isPriceVisible && (
              <Box mt={4}>
                <Text message={formatPrice(price, true)} size="14-24" bold />
              </Box>
            )
          }
        </Box>
      </Fragment>
    )

    const computedLink = (withoutLink || link === false) ? false : (link || url)

    return (
      <ProductCardBase
        className={cx(s.productBase, className)}
        containerClassName={containerClassName}
        _ref={this.setProductElementRef}
        data={data}
        link={computedLink}
        imgSrc={image || img} // TODO refactor to image
        content={contentNode}
        isWholeBlockAsButton={isWholeBlockAsButton}
        typeGroup={typeGroup}
        lazyImage={lazyImage}
        onBlockClick={this.handleBlockClick}
        onButtonClick={onButtonClick}
        onAfterAdd={onAfterAdd}
        addTo={addTo}
        buttonTitle={buttonTitle}
        isHoverEffect={isHoverEffect}
        metadata={metadata}
        onQuickViewClick={onQuickViewClick}
        snowplowMetadata={snowplowMetadata}
        defaultSelectedQuickViewType={defaultSelectedQuickViewType}
        isRatingStarBlack={isRatingStarBlack}
        isButtonAlways={isButtonAlways}
        isAddToButtonHidden={isAddToButtonHidden}
      >
        {children}
      </ProductCardBase>
    )
  }
}


export default Product
